import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const NahradniHodinovaSazba = {
	name: NAME,
	apiProvider,
	router,
};
